export function EmbedTest() {
  return (
    <div className="text-white">
      this is a blank page for testing the embeds on discord
    </div>
  );
}
